import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function FaqSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Es seguro si soy hipertenso?',
    a: 'Sí, el protocolo se basa en hidratación y plantas naturales. Damos alternativas al bicarbonato si tienes restricción de sodio.'
  }, {
    q: '¿Tengo que dejar el café para siempre?',
    a: 'No, solo durante la fase de sanación de 72 horas para permitir que tu esófago cicatrice.'
  }, {
    q: '¿Sirve para la hernia hiatal?',
    a: 'Totalmente. Ayuda a reducir la inflamación mecánica que causa la hernia al mejorar el vaciado gástrico.'
  }, {
    q: '¿Cuánto tardaré en notar resultados?',
    a: 'El alivio del ardor se nota en las primeras horas. La sanación del tejido toma el ciclo completo de 72 horas.'
  }, {
    q: '¿Cómo accedo al contenido después de comprar?',
    a: 'El acceso es inmediato y digital. Después de completar tu pago recibirás un correo con el enlace directo al material. En menos de 5 minutos puedes estar leyendo el protocolo desde tu celular, tablet o computadora.'
  }];
  return <section id="faq" className="py-24" data-id="element-132">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-133">
        <SectionHeader tag="Preguntas frecuentes" title={<>
              Resuelve tus dudas
              <br data-id="element-135" />
              antes de decidir
            </>} data-id="element-134" />

        <div className="stagger-children mt-12 space-y-2.5" data-id="element-136">
          {faqs.map((faq, idx) => {
          const isActive = activeIndex === idx;
          return <div key={idx} className="border border-white/10 rounded-lg overflow-hidden" data-id="element-137">
                <button className="w-full flex justify-between items-center p-5 md:px-6 bg-surface hover:bg-surface-2 transition-colors text-left gap-4" onClick={() => setActiveIndex(isActive ? null : idx)} data-id="element-138">
                  <h4 className="text-base font-semibold text-text-light" data-id="element-139">
                    {faq.q}
                  </h4>
                  <div className={`w-7 h-7 bg-accent/10 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 ${isActive ? 'rotate-180' : ''}`} data-id="element-140">
                    <ChevronDown className="w-3.5 h-3.5 text-accent" data-id="element-141" />
                  </div>
                </button>
                {isActive && <div className="p-5 md:px-6 bg-white/5 text-[15px] text-text-muted leading-relaxed border-t border-white/5 animate-in slide-in-from-top-2" data-id="element-142">
                    {faq.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}